export default __webpack_public_path__ + "static/Trash-Removal-c55de6a7f8e413c1c2bcc63bb9f1e29a.jpg";